module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daymodsnow@2-010b721b955183313fe2fd6ef0dd707e.png";